import styled from "styled-components";
import { theme } from "../../../../../../../helpers/theme";


interface ViewVariantsTitleProps {
    title: string;
}
export const ViewVariantsTitle = ({ title }: ViewVariantsTitleProps) => {

    return (
        <TitleWrapper>
            <Title>
                {title}
            </Title>
        </TitleWrapper>

    );
};

const TitleWrapper = styled.div`
display:flex;
flex-direction:column;
justyf-content:center;
max-width:494px;
margin-right:auto;
margin-left:auto;
`;
const Title = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 24px;
line-height: 32px;
text-align: center;
color: ${theme.colors.black_primaryText};
`